import LoadingPanel from './LoadingPanel';
export default LoadingPanel;